import { getAllDomains } from '../services/domain';
import { activateGsuite, activateMdello, deactivate } from '../services/napi';
import { DOMAINS_FETCH_SUCCESS, EMAIL_ACTIVATION_SUCCESS } from '../constant/actionType';

export function fetchDomainsAction() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await getAllDomains(projectId);
      dispatch({
        data: response.data.domains,
        type: DOMAINS_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function mdelloActivateAction(domainId, onSuccess, notify) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await activateMdello(projectId, domainId);
      if (response.data.success) {
        dispatch({
          data: false,
          type: EMAIL_ACTIVATION_SUCCESS
        });
        notify('Successfully Activated Mdello', 'success');
      } else {
        notify('Failed Mdello activation', 'warning');
      }
      onSuccess();
    } catch (error) {
      console.error(error);
      dispatch({
        data: false,
        type: EMAIL_ACTIVATION_SUCCESS
      });
      notify('Failed Mdello activation', 'warning');
    }
  };
}

export function gsuiteActivateAction(domainId, onSuccess, notify) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await activateGsuite(projectId, domainId);
      if (response.data.success) {
        dispatch({
          data: false,
          type: EMAIL_ACTIVATION_SUCCESS
        });
        notify('Successfully Activated Gsuite', 'success');
      } else {
        notify('Failed Gsuite activation', 'warning');
      }
      onSuccess();
    } catch (error) {
      console.error(error);
      dispatch({
        data: false,
        type: EMAIL_ACTIVATION_SUCCESS
      });
      notify('Failed Gsuite activation', 'warning');
    }
  };
}

export function deactivateAction(domainId, onSuccess, notify) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await deactivate(projectId, domainId);
      if (response.data.success) {
        dispatch({
          data: false,
          type: EMAIL_ACTIVATION_SUCCESS
        });
        notify('Successfully Deactivated', 'success');
      } else {
        notify('Failed Deactivation', 'warning');
      }
      onSuccess();
    } catch (error) {
      console.error(error);
      dispatch({
        data: false,
        type: EMAIL_ACTIVATION_SUCCESS
      });
      notify('Failed Deactivation', 'warning');
    }
  };
}

export function activationSuccess(boolean) {
  return async (dispatch) => {
    try {
      dispatch({
        data: boolean,
        type: EMAIL_ACTIVATION_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}
